<template>
  <div class="card">
    <div class="card-body">
      <span class="badge bg-dark">{{ 'Question' | translate }}</span>
    </div>
    <div class="card-body">
      <div class="" v-html="component.data.question.html"></div>

      <div class="col-12">
        <div
          class="mb-3 form-check"
          v-for="(answer, index) in answers"
          :key="index"
        >
          <input
            :ref="`answer${index}`"
            type="checkbox"
            class="form-check-input"
            @change="answerChanged"
            v-model="answer.selected"
          />
          <label class="form-check-label">{{ answer.label }}</label>
        </div>
        <div class="my-3" v-if="showSolution">
          <div v-if="answerIsValid">
            <i class="fas fa-trophy text-warning"></i>
            {{ 'Correct. Congratulations!' | translate }}
          </div>
          <div v-else class="text-danger">
            {{ 'Wrong answer, please try again.' | translate }}
          </div>
        </div>
        <button class="btn btn-primary btn-sm fw-bold" @click.prevent="check">
          {{ 'Check my answer' | translate }}
        </button>
        <button class="btn btn-link btn-sm" @click.prevent="toggleHint">
          {{'Solution' | translate}}
        </button>
      </div>
      <div
        class="lecture--quiz--hint col-12 pt-3 mt-3"
        v-html="component.data.solution.html"
        v-if="showHint"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['component'],
  data() {
    return {
      answers: this.component.data.answers.map((a) => {
        return { ...a, selected: false }
      }),
      validated: null,
      showSolution: false,
      showHint: false,
    }
  },
  computed: {
    answerIsValid() {
      return this.answers.every((answer, index) => {
        return answer.selected === answer.correct
      })
    },
  },
  methods: {
    answerChanged() {
      this.showSolution = false
    },
    check() {
      this.showSolution = true
    },
    toggleHint() {
      this.showHint = !this.showHint
    },
  },
}
</script>

<style></style>
